import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
export var JobHighlights = function (_a) {
    var highlights = _a.highlights;
    var _b = useState(false), showMore = _b[0], setShowMore = _b[1];
    var _c = useState(false), isOverflowing = _c[0], setIsOverflowing = _c[1];
    var contentRef = useRef(null);
    useEffect(function () {
        if (contentRef.current) {
            var hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
            setIsOverflowing(hasOverflow);
        }
    }, [highlights]);
    if (!highlights)
        return null;
    return (_jsxs("div", { className: 'flex flex-col gap-1 text-cardFontSize font-cardFontWeight', children: [_jsx("p", { className: 'font-cardSubHeadingFontWeight text-cardSubHeadingFontSize text-cardSubHeadingTextColor', children: "Job Highlights:-" }), _jsxs("div", { className: 'text-sm', children: [_jsx("div", { ref: contentRef, className: "whitespace-pre-wrap ".concat(showMore ? '' : 'line-clamp-5'), style: {
                            overflowWrap: 'anywhere',
                        }, dangerouslySetInnerHTML: { __html: highlights } }), isOverflowing && (_jsx("button", { onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowMore(function (prev) { return !prev; });
                        }, className: 'text-vjwPrimary hover:underline', children: showMore ? 'Show Less' : 'Show More' }))] })] }));
};
